import React from 'react';

const Footer = () => (
  <footer className="footer">
  </footer>
);

export default Footer;
/*
        <p className="mb-0 text-600">
          Footer in \src\components\footer\Footer.js{' '}
          <span className="d-none d-sm-inline-block">| </span>
          <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
          <a href="#">AlfaBeta</a>
        </p>
*/

/*
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';


    <Row className="justify-content-between text-center fs-10 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          Footer in \src\components\footer\Footer.js{' '}
        </p>
      </Col>
      <Col sm="auto">
        <p className="mb-0 text-600">v{version}</p>
      </Col>
    </Row>
*/